// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"94":"727973242bb33abd","203":"b4dd42ee905a148d"}[chunkId] + ".css";
};